import React, { useState, useEffect } from "react";
import { FaChevronDown, FaPhoneAlt } from "react-icons/fa";
import logo from "../../../assets/images/logo.webp";
import { MdMenu } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../../config/utilities/utils.constant";
function DesktopHeader({
  glassEffect = false,
  gradient = false,
  navItems,
  toggleMenuOpen,
  isMenuOpen,
  darkText,
  seoPage,
}) {
  const location = useLocation();
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [atTop, setAtTop] = useState(true);
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);
  const [openChildIndex, setOpenChildIndex] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setAtTop(currentScrollY === 0);

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // scrolling down
        setShowHeader(false);
      } else {
        // scrolling up
        setShowHeader(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);
  const handleSubMenuToggle = () => {
    setIsSubMenuOpen(false);
  };
  return (
    <>
      {/* Header for desktop */}

      <header
        className={`header w-full  fixed z-50 py-6 transition-all duration-300 transform max-h-60 ${
          atTop
            ? `${
                gradient && " bg-gradient-to-br from-[#6D1349] to-[#DF73FF]   "
              } ${
                glassEffect &&
                (seoPage
                  ? "bg-[rgba(255,255,255,0.1)] backdrop-blur-[10px] border border-[rgba(255,255,255,0.3)]  [border-image-source:radialgradient(81.59%_81.59%_at_18.48%_100%,_#FFFFFF_0%,_rgba(255,255,255,0)_100%),_radial-gradient(88.88%_88.88%_at_4.11%_6.2%,_#FFFFFF_0%,_rgba(255,255,255,0)_100%)] [border-image-slice:1] "
                  : " liquidGlassEffectForHeader")
              }
              }  translate-y-0 bgtransparent duration-100 ${darkText ? "text-dark" : "text-[#fff]"}  `
            : showHeader
              ? "translate-y-0 text-dark bg-white backdrop-blur shadow-[0_0_5px_rgb(204,204,204)]   "
              : "-translate-y-full    bg-white"
        }`}
      >
        <div className="container flex items-center justify-between ">
          {/* Logo */}
          <div>
            <Link
              to={routes.HOME}
              aria-label="Internal link to Apptalyst homepage"
            >
              <img
                src={logo}
                alt="Apptalyst official company logo"
                className="w-[10rem]  xl:w-[15rem] logo-width"
                width={20}
                height={20}
              />
            </Link>
          </div>

          {/*  Nav Links */}
          <nav className="hidden lg:flex font-medium custom-nav">
            <ul className="flex space-x-4 xl:space-x-6 custom-ul">
              {navItems.map((item, index) => (
                <li
                  key={index}
                  className="relative group cursor-pointer transition text-lg"
                  onMouseEnter={() => setOpenSubMenuIndex(index)}
                  onMouseLeave={() => setOpenSubMenuIndex(null)}
                >
                  <Link
                    to={item.link}
                    className={`transition after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-[2px]  ${
                      atTop ? "after:bg-[#FFC067]" : "after:bg-[#DF73FF]"
                    } after:rounded-full after:transition-all after:duration-300 group-hover:after:w-full flex  items-center space-x-2  ${
                      location.pathname === item.link
                        ? "after:w-full"
                        : "after:w-0"
                    }`}
                  >
                    {item.label}
                  </Link>

                  {/* Submenu */}
                  {item.subItems && openSubMenuIndex === index && (
                    <div
                      className={`absolute p-1 left-0 right-10 pt-2 min-w-[20rem] transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] transform ${
                        openSubMenuIndex === index
                          ? "opacity-100 scale-100 translate-y-0 pointer-events-auto"
                          : "opacity-0 scale-95 translate-y-2 pointer-events-none"
                      }`}
                    >
                      <ul className="bg-white shadow-xl border rounded-lg space-y-3 py-4 z-50">
                        {item.subItems.map((subItem, subIndex) => (
                          <li
                            key={subIndex}
                            onClick={() => setOpenSubMenuIndex(null)}
                            className={`${
                              location.pathname === subItem.link
                                ? "border-l-[6px] border-[#DF73FF]"
                                : "border-none hover:pl-1 text-lg"
                            } transition-all duration-200 relative group
                            `}
                            onMouseEnter={() => setOpenChildIndex(subIndex)}
                            onMouseLeave={() => setOpenChildIndex(null)}
                          >
                            <Link
                              to={subItem.link}
                              className="block px-4 py-2  text-gray-700"
                            >
                              {subItem.label}
                            </Link>

                            {/* 🔽 Nested submenu */}

                            {subItem.children &&
                              openChildIndex === subIndex && (
                                <div className=" absolute left-full top-0">

                                <ul className=" ml-2 bg-white shadow-xl border rounded-lg space-y-3 py-4 z-50 min-w-max">
                                  {subItem.children.map((child, childIndex) => (
                                    <li
                                      key={childIndex}
                                      className={`${
                                        location.pathname === child.link
                                          ? "border-l-[6px] border-[#DF73FF]"
                                          : "border-none hover:pl-1 text-lg"
                                      } transition-all duration-200 text-dark`}
                                    >
                                      <Link
                                        to={child.link}
                                        className="block px-4 py-2 text-dark"
                                      >
                                        {child.label}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                                </div>

                              )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          {/*  Contact Button */}
          <div className="hidden lg:flex items-center space-x-4 button-container">
            <div
              className={`${
                atTop
                  ? "bg-[#FFC067] text-dark  custom-button custom-button"
                  : " bg-[#DF73FF] text-dark"
              }   text-lg font-semibold px-3 py-2 rounded shadow flex items-center space-x-2 transition button2 cursor-pointer`}
            >
              <FaPhoneAlt />

              <span>
                {" "}
                <a href="tel:+17033812998">(703) 381-2998</a>
              </span>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden mobile-menu-wrapper">
            <button
              onClick={toggleMenuOpen}
              className="text-3xl focus:outline-none mobile-menu-button"
              aria-label="Hamburger icon for website’s menu"
              aria-controls="main-navigation"
              aria-expanded={isMenuOpen}
            >
              <MdMenu aria-hidden="true" />
            </button>
          </div>
        </div>
      </header>
    </>
  );
}

export default DesktopHeader;
